var $94b60c866ca5dfe6$exports = {};
$94b60c866ca5dfe6$exports = {
  "Empty": "\u7A7A\u767D"
};
export { $94b60c866ca5dfe6$exports as default };